module.exports = {
      id: "glyph:envelope-usage",
      viewBox: "0 0 19 15",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:envelope-usage",
      toString: function () {
        return this.url;
      }
    }